<template>
	<div>
		<vue-tel-input
			:modelValue="modelValue"
			class="vue-tel-input"
			:class="{ 'vue-tel-input--error': error || isError }"
			:inputOptions="inputOptions"
      :dropdownOptions="dropdownOptions"
			:defaultCountry="defaultCountry"
			:autoDefaultCountry="false"
			@validate="onValidate"
      @blur="onBlur"
			@update:modelValue="$emit('update:modelValue', $event)"
		/>
		<!-- :preferredCountries="['ua', 'kz', 'tr', 'az']" -->
		<div
			v-if="error || isError"
			class="vue-tel-input__error-message"
		>
			{{ errorMessages?.[0] }}
		</div>
	</div>
</template>

<script>
import { computed, ref } from 'vue'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import { useI18n } from 'vue-i18n'

export default {
	components: {
		VueTelInput,
	},
	props: {
		modelValue: {
			type: [String, Number],
		},
		label: {
			type: String,
		},
		showDialCode: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorMessages: {
			type: Array,
			default: () => [],
		},
		required: {
			type: Boolean,
			default: false,
		},
	},
	emits: {
		'update:modelValue': null,
		validate: null,
	},

	setup(props, { emit }) {
		const { t: $t } = useI18n()

		const isError = ref(false)

		const defaultCountry = computed(() => {
			return import.meta.env.VITE_APP_TEL_INPUT_DEFAULT_COUNTRY
		})

		const inputOptions = computed(() => ({
			placeholder: $t('Enter your phone number'),
			showDialCode: props.showDialCode,
		}))


    const dropdownOptions = ref({
      showSearchBox: true,
      showFlags: true,
      showDialCodeInList: true
    })



		const onValidate = (payload) => {
			emit('validate', payload)

			if (!props.modelValue && !props.required) {
				isError.value = false
				return
			}
			if (payload.valid) {
				isError.value = false
				return
			}

			isError.value = true
		}

    const onBlur = () => {
      if (!props.modelValue && !props.required) {
        isError.value = false
        return
      }
    }

		return {
			defaultCountry,
			inputOptions,
			isError,
      dropdownOptions,
			onValidate,
      onBlur,
		}
	},
}
</script>
<style lang="scss">
.vue-tel-input {
	position: relative;
	height: 40px;
	display: flex;
	align-items: end;
	border-radius: 0px;
	border-top: none;
	border-left: none;
	border-right: none;
	transition: all 0.2s ease-in;
	border-color: rgba(0, 0, 0, 0.3);

	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: rgb(var(--v-theme-primary));
		transform: scaleX(0);
		transition: all 0.15s ease-out;
	}

	&:hover {
		border-color: rgb(0, 0, 0, 0.87);
	}

	&:focus-within::after {
		transform: scaleX(1);
	}

	&:focus-within {
		box-shadow: none;
		border: none;
	}

	input {
		font-family: Inter;
		font-size: 14px;
		font-weight: 400;
		padding: 4px 8px;

		&::placeholder {
			font-size: 16px;
			font-weight: 400;
		}
	}

	&--error {
		border-color: rgb(var(--v-theme-error));
		&:focus-within::after {
			transform: scaleX(1);
			background-color: rgb(var(--v-theme-error));
		}
	}

	&__error-message {
		color: rgb(var(--v-theme-error));
		font-size: 12px;
		font-weight: 400;
		padding-top: 4px;
	}
}
</style>
